import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RatingsModel} from '../../model/ratings-model';
import {MatButton} from '@angular/material/button';


@Component({
    selector: 'app-select-product-dialog',
    templateUrl: './select-product-dialog.component.html',
    styleUrls: ['./select-product-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class SelectProductDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<SelectProductDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  products!: RatingsModel[];

  ngOnInit(): void {
    this.products = [];
    for (const model of this.data.products) {
      if (this.products.filter(product => product.productId === model.productId).length === 0) {
        this.products.push(model);
      }
    }
  }

  save(product: RatingsModel): void {
    this.dialogRef.close(product);
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
